import { destructureAxiosReq } from '../services/utils';
import sureAxios from '../services/sureAxios';

/**
 * Get search results from a query.
 *
 * @param {Object} opts The options.
 * @param {String} opts.authToken The auth token.
 * @param {String} opts.query The auth token.
 */
export function search(opts = {}) {
  return destructureAxiosReq(
    sureAxios.get(`/api/management/v1/search?q=${opts.query}`)
  );
}
